var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row no-gutters" }, [
    _c("div", { staticClass: "col-12 pt-2" }, [
      _c("strong", { class: _vm.capitalize ? "text-capitalize" : "" }, [
        _vm._v("\n      " + _vm._s(_vm.label) + "\n    "),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "referrerSelectContainer",
        staticClass: "col-12 d-flex flex-column",
        attrs: { id: _vm.name + "-select--container" },
      },
      [
        _c(
          "div",
          { staticClass: "form-group-material mb-1" },
          [
            _c("select2", {
              ref: "select",
              attrs: {
                id: _vm.name + "-select",
                multiple: "",
                data: _vm.data,
                name: "" + _vm.name,
                options: _vm.select2Options,
                "format-data": _vm.formatData,
                value: _vm.value,
                "init-on-mounted": false,
              },
              on: { change: _vm.handleSelect2Change },
            }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }